module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "hide-actions": "",
      "items": _vm.items
    }
  }, [_c('template', {
    slot: "no-data"
  }, [_c('v-alert', {
    attrs: {
      "outline": "",
      "value": true,
      "color": "warning",
      "icon": "warning"
    }
  }, [_vm._v("\n       No Genes are available\n    ")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26801621","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/partials/NoGenesDisplayTable.vue
// module id = 500
// module chunks = 0